import t, { forwardRef as o, useState as u } from "react";
import { Chip as m, Avatar as f } from "@mui/material";
import { I as n } from "./chunk.zlc_6vey.js";
import { g as C } from "./chunk.BurCwd5X.js";
const s = o(
  (e, i) => {
    const c = (a) => {
      e != null && e.onClick && (e == null || e.onClick(a));
    }, d = (e.variant ? e.variant : "filled") === "filled" ? e.selected && !e.disabled ? "filledSelected" : "filled" : e.selected && !e.disabled ? "outlinedSelected" : "outlined", [v, l] = u(!1);
    return /* @__PURE__ */ t.createElement(
      m,
      {
        id: e.id,
        disabled: e.disabled,
        label: e.label,
        onClick: c,
        variant: d,
        avatar: e.avatarSrc || e.avatarName ? /* @__PURE__ */ t.createElement(
          f,
          {
            src: e.avatarSrc,
            alt: e.avatarName ? e.avatarName : "Avatar"
          },
          e.avatarName ? e.avatarName[0] : /* @__PURE__ */ t.createElement(
            n,
            {
              icon: "person",
              variant: "outlined",
              sx: { fontSize: "12px" }
            }
          )
        ) : void 0,
        icon: e.icon ? /* @__PURE__ */ t.createElement(n, { icon: e.icon, disabled: e.disabled }) : void 0,
        onKeyDown: (a) => a.code === "Space" && l(!0),
        onKeyUp: (a) => a.code === "Space" && l(!1),
        className: v ? "Mui-active" : void 0,
        ref: i,
        onBlur: e.onBlur,
        onFocus: e.onFocus,
        onMouseOver: e.onMouseOver,
        onMouseLeave: e.onMouseLeave,
        ...C(i)
      }
    );
  }
);
export {
  s as C
};
